import styled from 'styled-components';
import { ApIcon, colors } from '@alixpartners/ui-components';

export const Container = styled.div`
  width: 720px;
  border: 1px solid ${colors.red1};
  padding: 12px 16px;
  background-color: ${colors.white};
  margin: 4px auto;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderText = styled.div`
  font-size: 16px;
  color: ${colors.grey7};
  font-weight: 400;
  letter-spacing: 0.3px;
  margin-left: 16px;
`;

export const ShowErrorsButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const ErrorsWrapper = styled.div<{ isExpanded: boolean }>`
  display: flex;
  flex-direction: column;
  height: ${(props) => (props.isExpanded ? 'auto' : '0px')};
  overflow: hidden;
`;

export const LineError = styled.div`
  width: 672px;
  background-color: ${colors.grey1};
  color: ${colors.grey7};
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.3px;
  padding: 12px 16px;
  margin-top: 8px;
`;

export const ErrorIcon = styled(ApIcon)`
  color: ${colors.red2};
`;

export const Footer = styled.div`
  display: flex;
  margin-top: 12px;
`;
